<script>
import Logo from './sidebarComponents/Logo.vue';

export default {
  components: {
    Logo,
  },
  props: {
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<template>
  <div
    class="flex items-center justify-between w-full h-16 px-4 md:hidden mobile-header-bg border-b border-white/10"
  >
    <Logo
      :source="logoSource"
      :name="installationName"
      :account-id="accountId"
    />
    <button
      class="p-2 -ml-2 rounded-lg hover:bg-white/10 text-slate-100"
      @click="$emit('toggleSidebar')"
    >
      <fluent-icon icon="navigation" size="24" />
    </button>
  </div>
</template>

<style scoped>
.mobile-header-bg {
  background-color: #002750;
}
</style>
